// import { lazy } from 'react';
import SalesLayOut from "views/Sales-Sections/SalesLayOut";
import BatchPrint from "views/PrintTypes/BatchPrint";
import Print from "views/print/Print";
import A4Print from "views/PrintTypes/A4Print";
import A4PrintTwo from "views/PrintTypes/A4PrintTwo";
import ThermalPrint from "views/PrintTypes/ThermalPrint";
import A4PurchasePrint from "views/PrintTypes/A4PurchasePrint";
import ThermalPurchase from "views/PrintTypes/ThermalPurchase";
import A4PrintTaxVAt from "views/PrintTypes/TaxVat/A4PrintTaxVAt";
import ThermalPrintTaxVat from "views/PrintTypes/TaxVat/ThermalPrintTaxVat";
import ReceiptPaymentPrint from "views/PrintTypes/ReceiptPaymentPrint";
import ThermalInch from "views/PrintTypes/ThermalInch";
import SalesReportPrint from "views/PrintTypes/SalesReportPrint";
import CustomPrint from "views/reports/components/CustomPrint";
import CustomPrintStock from "views/reports/components/CustomPrintStock";

const PrinterRoutes = {
  path: "printer",
  element: <SalesLayOut />,
  children: [
    {
      path: "printerCheck",
      element: <Print />,
    },
    {
      path: "thermalPrint",
      element: <ThermalPrint />,
    },
    {
      path: "a4",
      element: <A4Print />,
    },
    {
      path: "a4Two",
      element: <A4PrintTwo />,
    },
    {
      path: "batchPrint",
      element: <BatchPrint />,
    },
    {
      path: "purchaseA4",
      element: <A4PurchasePrint />,
    },
    {
      path: "purchaseThermal",
      element: <ThermalPurchase />,
    },
    {
      path: "lazerA4PrintTaxVat",
      element: <A4PrintTaxVAt />,
    },
    {
      path: "ThermalPrintTaxVat",
      element: <ThermalPrintTaxVat />,
    },
    {
      path: "a5Print",
      element: <ReceiptPaymentPrint />,
    },
    {
      path: "thermalPrint4Inch",
      element: <ThermalInch />,
    },
    {
      path: "salesReportPrint",
      element: <SalesReportPrint />,
    },
    {
      path: "stockReportPrint",
      element: <CustomPrint />,
    },
    {
      path: "customPrintStock",
      element: <CustomPrintStock />,
    },
  ],
};
export default PrinterRoutes;
